import { cn } from '@exam-room/utils';

interface TableHeaderCellProps extends React.ThHTMLAttributes<HTMLTableHeaderCellElement> {
  className?: string;
}

export default function TableHeaderCell({ children, className, ...props }: TableHeaderCellProps) {
  return (
    <th className={cn('p-3 font-semibold', className)} {...props}>
      {children}
    </th>
  );
}
